import React from "react";
import styles from "./HorizontalLine.module.css";

function HorizontalLine() {
    return (
        <hr className={styles.line}/>
    );
}

export default HorizontalLine;
